<template>
  <!-- page-edit-block -->
  <div v-if="editBlock && blockName" class="page-edit-block">
    <section
      class="
        add_new_head add_new_head-h
        white--body
        tx--bege
        relative
        cover
        m_bg_blue-doc
      "
    >
      <div
        class="popup_close close-animate"
        @click="$router.replace(backToDashboardUrl)"
      >
        <a>
          <CloseSvg />
        </a>
      </div>
      <div class="inner_width flex flex--column center">
        <h1 class="title">
          <span class="bold desk-block">עריכת בלוק מרפאה</span>
          {{ blockName }}
        </h1>
        <div class="text">
          {{ editBlock.start_date }}
          {{ editBlock.dup_blocks.length > 0 ? "" : "(ללא חזרה)" }}
          <br />
          {{ appointmentTypeInsurance }}
        </div>
      </div>
    </section>
    <section class="page-edit-padd bg--white">
      <validation-observer ref="editBlockForm" class="block max--680">
        <form
          @submit.prevent="submitEditBlock"
          v-promise-btn="{ action: 'submit' }"
          autocomplete="off"
        >
          <div class="page-edit-hors bg--yellow center">
            שעות הבלוק: {{ editBlock.end_time + " - " + editBlock.start_time }}
          </div>
          <div class="text mb-15 center let-1">
            ניתן לערוך את שעות הבלוק בהתאם לזמינות חדר המרפאה
          </div>
          <div class="flex desk-flex--top edit-hours-start desk-center">
            <div class="page-edit-row flex desk-block">
              <div style="font-size: 26px;">שעת התחלה</div>
              <div class="form_input surg-time">
                <validation-provider
                  name="start_time"
                  :rules="{
                    required: true,
                    timeFormat: [end_time],
                    interval: [end_time]
                  }"
                  v-slot="{ errors }"
                >
                  <cleave
                    :value="start_time"
                    :options="options"
                    @input="onCleave('start_time', $event)"
                    @focus.native="e => e.target.select()"
                    name="time"
                  ></cleave>
                  <span class="error-message">{{ errors[0] }}</span>
                </validation-provider>
              </div>
            </div>
            <div class="page-edit-row flex desk-block">
              <div style="font-size: 26px;">שעת סיום</div>
              <div class="form_input surg-time">
                <validation-provider
                  name="end_time"
                  :rules="{
                    required: true,
                    timeFormat: [start_time],
                    interval: [start_time],
                    isBigger: [start_time]
                  }"
                  v-slot="{ errors }"
                >
                  <cleave
                    :value="end_time"
                    :options="options"
                    @input="onCleave('end_time', $event)"
                    @focus.native="e => e.target.select()"
                    name="time"
                  ></cleave>
                  <!-- <input type="text" v-mask="['##:##']" v-model="end_time" /> -->
                  <span class="error-message">{{ errors[0] }}</span>
                </validation-provider>
              </div>
            </div>
          </div>
          <!-- <div
            v-if="editBlock.dup_blocks.length > 1"
            class="form_check form_radio"
          >
            <label class="form_check_tx"
              >עדכון בלוק ב - {{ editBlock.start_date }} בלבד
              <input
                type="radio"
                name="edit_all_blocks"
                v-model="update_all"
                value="no"
              /><span class="checkmark"></span>
            </label>
          </div>
          <div
            class="form_check form_radio"
            v-if="editBlock.dup_blocks.length > 1"
          >
            <label class="form_check_tx"
              >עדכן כל הבלוקים החוזרים הבאים
              <input
                type="radio"
                name="edit_all_blocks"
                v-model="update_all"
                value="yes"
              /><span class="checkmark"></span>
            </label>
          </div> -->

          <div class="center">
            <div class="error-message center" v-if="serverMessage">
              {{ serverMessage }}
            </div>
            <button
              type="submit"
              class="bt_blue w-100"
              :class="{ bt_disable: notValid }"
            >
              שמירה
            </button>
          </div>
        </form>
      </validation-observer>
    </section>
  </div>
  <!-- end page-edit-block -->
</template>

<script>
import { mapGetters } from "vuex";
import CloseSvg from "@/assets/img/svg/close.svg";
import BlockEditPop from "@/components/Popups/BlockEdit";
import Error from "@/components/Popups/Error";
import BlockEditInvalidPop from "@/components/Popups/BlockEditInvalid";
import Cleave from "vue-cleave-component";
import { getHash } from "../../../utilities/hash";
import { backClickTimeout, isMobile } from "../../../utilities/globals";

export default {
  name: "EditBlock",
  components: {
    CloseSvg,
    Cleave
  },
  data: function() {
    return {
      options: {
        time: true,
        timePattern: ["h", "m"]
      },
      page_loaded: false,
      serverMessage: "",
      block_repeat: "",
      editBlock: null,
      editAllBlock: false,
      start_time: "",
      end_time: "",
      update_all: "",
      apps: [],
      currentDateBlocks: [],
      blockName: ""
    };
  },
  async mounted() {
    // get block info
    const blockInfoRes = await this.$API.getBlockInfo(this.$route.params.id);
    if (!blockInfoRes) this.$modal.show(Error);
    this.editBlock = blockInfoRes;
    this.start_time = blockInfoRes.start_time;
    this.end_time = blockInfoRes.end_time;

    // get block appointments
    const events = await this.$API.getFullCalendarEvents(
      this.activeUser.user_id,
      "",
      "appointment",
      this.$moment(this.editBlock.start_date, "DD/MM/YYYY").format(
        "YYYY-MM-DD"
      ),
      this.$moment(this.editBlock.end_date, "DD/MM/YYYY").format("YYYY-MM-DD"),
      this.editBlock.id
    );
    const blockFromCalendar = events.find(
      ev => ev.background_block_id == this.editBlock.id && !ev.appointment_id
    );
    this.blockName =
      blockFromCalendar && blockFromCalendar.block_type_name
        ? blockFromCalendar.block_type_name
        : this.editBlock.block_type_name;
    if (events && events.length) {
      let tmp = events.filter(ev => ev.appointment_id);
      let start;
      let end;
      tmp.forEach(ev => {
        let s = this.$moment(ev.start).format("HH:mm");
        let e = this.$moment(ev.end).format("HH:mm");
        if (!start || s < start) start = s;
        if (!end || e > end) end = e;
      });
      this.apps.push(start);
      this.apps.push(end);
    }

    // Get all blocks - by current block date
    const date_obj = this.$moment(this.editBlock.start_date, "DD/MM/YYYY");
    const startDate = date_obj.format("YYYY-MM-DDTHH:mm");
    const endDate = date_obj.format("YYYY-MM-DDT23:59");
    const resBlocks = await this.$API.getFullCalendarEvents(
      this.activeUser.user_id,
      this.activeDoctor.id,
      "appointment",
      startDate,
      endDate
    );
    this.currentDateBlocks = resBlocks.filter(
      ev =>
        ev.background_block_id && this.editBlock.id != ev.background_block_id
    );
    setTimeout(() => {
      if (this.hashData && this.hashData.blockId) {
        this.end_time = this.hashData.blockEndTime;
        this.$modal.show(BlockEditInvalidPop, {
          block: this.editBlock,
          title: "לערוך"
        });
      }
    }, backClickTimeout());
  },
  computed: {
    ...mapGetters(["activeDoctor", "activeUser"]),
    notValid() {
      // if (this.editBlock.dup_blocks.length <= 1) return false;
      // if (!this.update_all) return true;
      // return false;
      return false;
    },
    appointmentTypeInsurance() {
      if (!this.editBlock || !this.editBlock.appointments_ob) return "";
      const data = this.editBlock.appointments_ob;
      const ins = [
        ...new Set(
          data.map(item => `${item.appointment_type} - ${item.insurance}`)
        )
      ];
      return ins.join(", ");
    },
    backToDashboardUrl() {
      const startDate = this.reformatDate(this.editBlock.start_date);
      return `/dashboard#&date=${startDate}&view=day`;
    }
  },
  methods: {
    onCleave(type, ev) {
      if (ev) {
        this[type] = ev.substring(0, 2) + ":" + ev.substring(2, ev.length);
      } else {
        this[type] = ev;
      }
    },
    reformatDate(originalDate) {
      const splitDate = originalDate.split("/");
      const formattedDate = `${splitDate[2]}-${splitDate[1]}-${splitDate[0]}`;
      return formattedDate;
    },
    async submitEditBlock() {
      const valid = await this.$refs.editBlockForm.validate();
      if (!valid) return;
      let new_block = [];
      this.serverMessage = "";
      let block_title = this.editBlock.block_type_name;
      let date = this.$moment(this.editBlock.start_date, "DD/MM/YYYY");
      let full_start_time =
        date.format("YYYY-MM-DD") + "T" + this.start_time + ":00";
      let full_end_time =
        date.format("YYYY-MM-DD") + "T" + this.end_time + ":00";

      const startMoment = this.$moment(full_start_time, "YYYY-MM-DDTHH:mm:ss");
      const endMoment = this.$moment(full_end_time, "YYYY-MM-DDTHH:mm:ss");
      // if blocks in same day
      if (this.currentDateBlocks && this.currentDateBlocks.length) {
        for (let i = 0; i < this.currentDateBlocks.length; i++) {
          const blockStart = this.$moment(
            this.currentDateBlocks[i].start,
            "YYYY-MM-DDTHH:mm:ss"
          );
          const blockEnd = this.$moment(
            this.currentDateBlocks[i].end,
            "YYYY-MM-DDTHH:mm:ss"
          );
          if (
            (startMoment.isAfter(blockStart) &&
              startMoment.isBefore(blockEnd)) ||
            (endMoment.isBefore(blockEnd) && endMoment.isAfter(blockStart))
          ) {
            this.serverMessage = `קיים בלוק אחר בין השעות ${blockEnd.format(
              "HH:mm"
            )} - ${blockStart.format("HH:mm")}`;
            return;
          }
        }
      }

      // If apps in the block
      if (this.apps && this.apps.length) {
        if (this.start_time > this.apps[0] || this.end_time < this.apps[1]) {
          this.$modal.show(BlockEditInvalidPop, {
            block: this.editBlock,
            title: "לערוך"
          });
          window.location.hash = getHash({
            blockId: this.editBlock.id,
            blockEndTime: this.end_time
          });
          return;
        }
      }

      let timeDiff = this.$moment(full_start_time);
      const diffInMinutes = Math.abs(
        timeDiff.diff(this.$moment(full_end_time), "minutes")
      );

      if (diffInMinutes < 5) {
        this.serverMessage =
          "שגיאה בעריכת בלוק יש לעשות בלוק מינימלי של 5 דקות";
        return;
      }

      // if (this.update_all == "no") {
      // if only this block
      new_block.push({
        id: this.editBlock.id,
        room: this.editBlock.type + "_" + this.editBlock.room_number,
        start: full_start_time,
        end: full_end_time,
        title: block_title
      });
      // } else {
      //   // if dup_blocks
      //   room = this.editBlock.type + "_" + this.editBlock.room_number;
      //   new_block.push({
      //     id: this.editBlock.id,
      //     room: room,
      //     start: full_start_time,
      //     end: full_end_time,
      //     title: block_title
      //   });
      //   this.editBlock.dup_blocks.forEach(block => {
      //     date = this.$moment(block.start_date, "DD/MM/YYYY");
      //     let check_date = this.$moment(
      //       this.editBlock.start_date,
      //       "DD/MM/YYYY"
      //     );
      //     full_start_time =
      //       date.format("YYYY-MM-DD") + "T" + block.start_time + ":00";
      //     full_end_time =
      //       date.format("YYYY-MM-DD") + "T" + block.end_time + ":00";
      //     if (date.isAfter(check_date)) {
      //       new_block.push({
      //         id: block.block_id,
      //         room: room,
      //         start: full_start_time,
      //         end: full_end_time,
      //         title: block_title
      //       });
      //     }
      //   });
      // }

      // If change start time
      if (this.editBlock.start_date != this.start_time) {
        const res = await this.$API.editBlockStartTime(
          this.editBlock.id,
          this.start_time + ":00"
        );
        if (res.status != "OK") {
          this.serverMessage = res.message;
          return;
        }
      }
      // Edit api
      this.$API
        .editBlocks(new_block)
        .then(res => {
          if (res.status == "OK") {
            this.$API
              .getBlockInfo(res.block_id)
              .then(res => {
                this.serverMessage = "";
                this.$modal.show(BlockEditPop, { block: res });
              })
              .catch(e => {
                this.$modal.show(Error);
              });
          }
          resolve(true);
        })
        .catch(e => {
          reject(true);
          this.serverMessage = "שגיאת שרת";
          this.$modal.show(Error);
        });
    }
  }
};
</script>
